// Window scroll script
jQuery(window).scroll(function($) {
    jQuery(".site-header").addClass("sticky");

    var scroll = jQuery(window).scrollTop();
    var scrollBottom = jQuery(document).height() - jQuery(window).height() - jQuery(window).scrollTop();
    //console.log($(document).height() - $(window).height() - $("#enquiry").height())

    if (scroll <= 50) {
        jQuery(".site-header").removeClass("sticky");
    }
});

jQuery(document).ready(function ($) {
  
  // Modal
  MicroModal.init();
  
  // AOS Animation
  AOS.init({
    duration: 1200,
  });
  
});